import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";
import moment from "moment";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { isPlanRouteEnabled } from "../utils/planFeatureAccess";
import {
	getModuleAccessForPath,
	hasEffectiveModulePermission,
} from "../utils/modulePermissions";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading, user, modulePermissions, modulePermissionsLoaded } = useContext(AuthContext);

	// Verificar se a empresa está vencida
	const isCompanyExpired = () => {
		if (!user || !user.company || user.company.id === 1) {
			return false; // Empresa ID 1 nunca expira
		}

		const dueDate = user.company.dueDate;
		if (!dueDate) return false;

		// Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
		const hojeInicio = moment().startOf('day');
		const vencimentoInicio = moment(dueDate).startOf('day');
		
		// Empresa está vencida apenas após o dia do vencimento
		return hojeInicio.isAfter(vencimentoInicio, 'day');
	};

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		const userProfile = String(user?.profile || "").toLowerCase();
		const redirectPath = userProfile === "motoqueiro" ? "/motoqueiro" : "/tickets";
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: redirectPath, state: { from: rest.location } }} />;
			</>
		);
	}

	// Se está autenticado e a empresa está vencida
	if (isAuth && isPrivate && isCompanyExpired()) {
		// Permite acesso ao /financeiro-aberto e /knowledge-base
		if (rest.path !== "/financeiro-aberto" && rest.path !== "/knowledge-base") {
			return (
				<>
					{loading && <BackdropLoading />}
					<Redirect to={{ pathname: "/financeiro-aberto", state: { from: rest.location } }} />
				</>
			);
		}
	}

	if (isAuth && isPrivate) {
		const currentPlan = user?.company?.plan;
		const currentPath = rest.location?.pathname || rest.path || "";

		if (!isPlanRouteEnabled(currentPath, currentPlan)) {
			return (
				<>
					{loading && <BackdropLoading />}
					<Redirect to={{ pathname: "/tickets", state: { from: rest.location } }} />
				</>
			);
		}

		const requiredModulePermission = getModuleAccessForPath(currentPath);
		if (requiredModulePermission && !modulePermissionsLoaded) {
			return <BackdropLoading />;
		}

		if (
			requiredModulePermission &&
			!hasEffectiveModulePermission(modulePermissions, requiredModulePermission, user)
		) {
			return (
				<Redirect to={{ pathname: "/tickets", state: { from: rest.location } }} />
			);
		}
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
